import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from '../config/apiconfig';

function Section({ title, children }) {
  return (
    <section className="bg-white rounded-xl shadow p-6 mb-8">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      {children}
    </section>
  );
}

export default function AdminProductsMachines() {
  const [products, setProducts] = useState([]);
  const [machines, setMachines] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [assignedMachines, setAssignedMachines] = useState([]);
  const [newProduct, setNewProduct] = useState('');
  const [newMachine, setNewMachine] = useState('');

  const authHeaders = useMemo(() => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
  }, []);

  async function loadProducts() {
    const r = await fetch(`${API_BASE_URL}/admin/products`, { headers: authHeaders });
    if (r.ok) setProducts(await r.json());
  }
  async function loadMachines() {
    const r = await fetch(`${API_BASE_URL}/admin/machines`, { headers: authHeaders });
    if (r.ok) setMachines(await r.json());
  }
  async function loadAssigned(productId) {
    const r = await fetch(`${API_BASE_URL}/admin/product-machines/${productId}`, { headers: authHeaders });
    if (r.ok) setAssignedMachines(await r.json());
  }

  useEffect(() => { loadProducts(); loadMachines(); }, []);
  useEffect(() => { if (selectedProduct) loadAssigned(selectedProduct.id); }, [selectedProduct]);

  async function addProduct() {
    if (!newProduct.trim()) return;
    const r = await fetch(`${API_BASE_URL}/admin/products`, { method:'POST', headers: authHeaders, body: JSON.stringify({ name: newProduct }) });
    if (r.ok) { setNewProduct(''); loadProducts(); }
  }
  async function addMachine() {
    if (!newMachine.trim()) return;
    const r = await fetch(`${API_BASE_URL}/admin/machines`, { method:'POST', headers: authHeaders, body: JSON.stringify({ name: newMachine }) });
    if (r.ok) { setNewMachine(''); loadMachines(); if (selectedProduct) loadAssigned(selectedProduct.id); }
  }
  async function assign(machineId) {
    if (!selectedProduct) return;
    await fetch(`${API_BASE_URL}/admin/product-machines/assign`, { method:'POST', headers: authHeaders, body: JSON.stringify({ product_id: selectedProduct.id, machine_id: machineId }) });
    loadAssigned(selectedProduct.id);
  }
  async function unassign(machineId) {
    if (!selectedProduct) return;
    await fetch(`${API_BASE_URL}/admin/product-machines/unassign`, { method:'POST', headers: authHeaders, body: JSON.stringify({ product_id: selectedProduct.id, machine_id: machineId }) });
    loadAssigned(selectedProduct.id);
  }

  const assignedIds = new Set(assignedMachines.map(m=>m.machine_id));

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Section title="Products">
        <div className="flex gap-2 mb-3">
          <input className="border rounded p-2 flex-1" placeholder="New product name" value={newProduct} onChange={e=>setNewProduct(e.target.value)} />
          <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={addProduct}>Add</button>
        </div>
        <ul className="divide-y">
          {products.map(p => (
            <li key={p.id} className={`p-2 cursor-pointer rounded ${selectedProduct?.id===p.id?'bg-indigo-50':''}`} onClick={()=>setSelectedProduct(p)}>
              {p.name} <span className="text-xs text-gray-500">({p.product_code})</span>
            </li>
          ))}
        </ul>
      </Section>

      <Section title="Machines">
        <div className="flex gap-2 mb-3">
          <input className="border rounded p-2 flex-1" placeholder="New machine name" value={newMachine} onChange={e=>setNewMachine(e.target.value)} />
          <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={addMachine}>Add</button>
        </div>
        <ul className="divide-y">
          {machines.map(m => (
            <li key={m.id} className="p-2 flex items-center justify-between">
              <span>{m.name} <span className="text-xs text-gray-500">({m.machine_code})</span></span>
              {selectedProduct && (
                assignedIds.has(m.id) ? (
                  <button className="px-2 py-1 text-sm bg-red-100 text-red-700 rounded" onClick={()=>unassign(m.id)}>Unassign</button>
                ) : (
                  <button className="px-2 py-1 text-sm bg-green-100 text-green-700 rounded" onClick={()=>assign(m.id)}>Assign</button>
                )
              )}
            </li>
          ))}
        </ul>
      </Section>

      <Section title="Assigned Machines">
        {!selectedProduct ? (
          <div className="text-gray-500">Select a product to view mappings.</div>
        ) : (
          <div>
            <div className="mb-2 font-medium">{selectedProduct.name}</div>
            <ul className="list-disc pl-5">
              {assignedMachines.map(a => (
                <li key={a.machine_id}>{a.name}</li>
              ))}
              {assignedMachines.length===0 && <li className="text-gray-500">No machines assigned.</li>}
            </ul>
          </div>
        )}
      </Section>
    </div>
  );
}
